module.exports = new __parcel__URL__("Tools.65e8a1d6.svg").toString();